import axios, { AxiosInstance } from 'axios';

import { API_BASE_URL } from '../config/config';

// For the endpoints anyone may call without an account (the ones on SecuredMiddleware's
// whitelist), used by the public pages: a shared Courses Played list and a course's profile.
//
// Deliberately without axiosInstance's interceptors. Those attach the stored token and, when it is
// stale, try to refresh it and send the visitor to /login if that fails. On a public page that is
// exactly wrong: a friend who once signed in on this browser, with a long-expired session, would
// be bounced to a login screen instead of seeing the list they were sent. A public endpoint needs
// no token, so there is nothing to refresh and nowhere to redirect: an error here is just an error,
// and the page shows its own message.
//
// Same base URL, headers and raw transformResponse as axiosInstance, because the generated NSwag
// clients parse the JSON themselves.
const publicAxiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  transformResponse: [],
});

export default publicAxiosInstance;
